import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import classNames from "classnames";
import { useContext, useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { useHistory } from "react-router";

import Loader from "src/app/components/loader/Loader";
import statisticsCSS from "src/app/modules/admin/components/statistics/Statistics.module.css";
import { generateTitleTooltip, STATISTICS_TABS } from "src/app/modules/admin/components/statistics/constants";
import { ROUTES } from "src/config/constants";
import { ModalContext } from "src/contexts/ModalContext";
import { ApiResult } from "src/core/helpers/api/ApiResult";
import { StatisticsService } from "src/core/services/statistics/StatisticsService";

import StatisticsList from "./StatisticsList";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Systems = ({
  activeTab,
  filteredDateFrom,
  filteredDateTo,
}: {
  activeTab: string;
  filteredDateFrom: Date | undefined;
  filteredDateTo: Date | undefined;
}) => {
  const modalData = useContext(ModalContext);
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [inputData, setInputData] = useState<any>([]);

  const labels = [
    "#1",
    "#2",
    "#3",
    "#4",
    "#5",
    "#6",
    "#7",
    "#8",
    "#9",
    "#10",
    "#11",
    "#12",
    "#13",
    "#14",
    "#15",
    "#16",
    "#17",
    "#18",
    "#19",
    "#20",
    "#21",
    "#22",
    "#23",
    "#24",
    "#25",
    "#26",
    "#27",
    "#28",
    "#29",
    "#30",
  ];

  const data = {
    labels: labels,
    datasets: [
      {
        data: inputData.map((x: any) => x.projectsCount),
        backgroundColor: "#0089bd",
        hoverBackgroundColor: "#009CD7",
      },
    ],
  };

  useEffect(() => {
    const dateFrom = filteredDateFrom ? filteredDateFrom.toDateString() : null;
    const dateTo = filteredDateTo ? filteredDateTo.toDateString() : null;

    StatisticsService.getSystemsTop30(dateFrom, dateTo)
      .then((response) => {
        if (response) {
          setInputData(response);
        }
      })
      .catch((e: ApiResult) => {
        if (!modalData?.content?.contentSet) {
          modalData?.triggerError(e);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [loading, filteredDateFrom, filteredDateTo, modalData]);

  const options = {
    responsive: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      datalabels: {
        display: false,
      },
      tooltip: {
        enabled: false,
        displayColors: false,
        backgroundColor: "#fff",
        titleColor: "#000",
        bodyColor: "000",
        padding: 10,
        cornerRadius: 10,
        borderWidth: 1,
        borderColor: "#009cd7",
        caretSize: 0,
        caretPadding: 15,
        external: function (context: any) {
          generateTitleTooltip(context, "chartjs-tooltip-systems", labels, inputData, 0);
        },
      },
    },
    scales: {
      x: {
        display: true,
        ticks: {
          color: "#009CD7",
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        },
        grid: {
          borderColor: "#80A5B5",
          display: false,
        },
      },
      y: {
        display: true,
        ticks: {
          color: "#009CD7",
        },
        grid: {
          borderColor: "#80A5B5",
          borderDash: [10, 10],
        },
      },
    },
    elements: {
      bar: {
        borderWidth: 1,
        borderColor: "#0089BD",
        borderRadius: [3, 3, 0, 0],
      },
    },
    barThickness: 18,
    maxBarThickness: 18,
  };

  const navigateToAdminProjects = (systemId: any) => {
    history.push({
      pathname: ROUTES.adminProjects,
      state: {
        systemId: systemId,
        filteredDateFrom: filteredDateFrom,
        filteredDateTo: filteredDateTo,
      },
    });
  };

  return (
    <div className={classNames("u-border-box", "u-col-xs-12", activeTab === STATISTICS_TABS.SYSTEMS ? "" : "u-none", statisticsCSS.listContainer)}>
      {/* Desktop projects HTML */}
      <div className={classNames(statisticsCSS.desktopChart)}>
        <div id="canvasContainer" className="u-box u-flex-wrap u-t-align-center u-pt20px">
          <Bar width="1260" height="600" options={options} data={data} />
        </div>
      </div>
      <StatisticsList inputData={inputData} shouldNavigateToAdminProjects={true} navigateToAdminProjects={navigateToAdminProjects} countLabel={"upita"} />
      {loading && <Loader />}
    </div>
  );
};

export default Systems;
